module.exports = __webpack_public_path__ + "static/app-shot-1-5-6ea78b7c90ce03469c0d577977b1e99b.jpg";